module.exports = __webpack_public_path__ + "static/media/pw.9772c55d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pw.svg
// module id = 2194
// module chunks = 0